import Service from "@/services/dashboard.service.js"
import Helper from "@/helpers/helpers.js"

const tempLocal = localStorage.getItem("changed_profile_dashboard");
let localProfile = null;
if (tempLocal) {
	localProfile=JSON.parse(tempLocal);
	// console.log("CHAGES ", tempLocal)
}

export const Dashboard = {
	namespaced : true,
	state :{
		list: [],
		currentProfile: {
			dashboard: [], 
			options:{
				draggable  			: false,
				resizable 			: true,
				// responsive 			: false,
				prevent_collision 	: false,
				vertical_compact 	: false,
			}, 
			alertMode: "snack",
			name : "",
		},		
		isLoaded: false,
		isLoading: false,
		isLoadingProfile : false,
		sidebarGrid : false,
		position_x : 0,
		position_y : 0,
		functionCheckData:null,
	},
	getters:{
		getList:(state)=>{
			return state.list
		},
		getItemById : (state)=>(id) =>{
	        return state.list.find(x=> x.id == id) || null;
	    },
	    getIdxProfileById:(state)=>(val)=>{
	    	return state.currentProfile.dashboard.findIndex(x=> x.Id === val);
	    },
	    getCurrentProfile:(state)=>{
	    	return state.currentProfile; // { dashboard , options, alertMode}
	    },
	    getIsLoaded:(state)=>{
	    	return state.isLoaded;
	    },
	    getIsLoadingProfile:(state)=>{
	    	return state.isLoadingProfile;
	    },
	    getSidebarGrid:(state)=>{
	    	return state.sidebarGrid;
	    },
	    getPositionX:(state)=>{
	    	return state.position_x;
	    },	    
	    getPositionY:(state)=>{
	    	return state.position_y;
	    },
	    camVisibility:(state)=>{
	    	// Acceder directamente al estado para evitar problemas con getters/setters
	    	try {
	    		// Intentar acceder directamente al estado
	    		if (state.currentProfile && state.currentProfile.camVisibility) {
	    			return state.currentProfile.camVisibility;
	    		}
	    		return {};
	    	} catch (error) {
	    		console.error('❌ ERROR en getter camVisibility:', error);
	    		return {};
	    	}
	    },
	},
	actions:{
		getList({state,commit}){
			// console.log("LIST ", Service)
			if (!state.isLoading) {				
				return Service.getList().then(res=>{
        			if (res && res.data && res.data.rows && res.data.rows.length > 0) {
						res.data.rows.forEach((dash)=>{
	        				if (typeof dash.dashboard == "string") {
        						let temp = Helper.to_object(dash.dashboard); 
        						if (Array.isArray(temp)) {
        							dash.dashboard = temp;
        						} else if (temp) {
        							dash.dashboard = [ temp ];
        						} else {
        							dash.dashboard = [];
        						}
        						dash.options = Helper.to_object(dash.options);
        					}
	        			});
						commit("setList",res.data.rows)
						commit("setIsLoaded",true);
					}
					return Promise.resolve(res);
				}).catch(error=>{
					console.warn("Erro get list dashboard ", error)
					return Promise.reject(error)
				});
			}
			return Promise.reject(false)
		},
		saveList({commit, state, getters, rootGetters}, params){
			const item = {...params}
			// Inyecta camVisibility en cada objeto parking o register_events_parking
			// Usar el getter para obtener camVisibility
			const camVisibility = getters.camVisibility || {};
			
			let dashboardArray = Array.isArray(state.currentProfile.dashboard) ? [...state.currentProfile.dashboard] : [];
			
			dashboardArray = dashboardArray.map(widget => {
				if (widget.component === 'parking' || widget.component === 'register_events_parking') {
					return { ...widget, camVisibility };
				}
				return widget;
			});
			
			item.dashboard = Helper.to_string(dashboardArray);
			item.options = Helper.to_string(item.options);
			
			return Service.saveDashboard(item).then(res=>{
				if (res && res.data) {
					params.id = res.data.id
					commit("addList", params);
				}
				return Promise.resolve(res);
			}).catch(error=>{
				console.warn("Erro save list dashboard ", error)
				return Promise.reject(error)
			})
		},
		updateList({commit, state, getters, rootGetters}, params){
			console.log("🔄 updateList llamado con params:", params);
			try {
				const item = {...params}
				
				// Validar que los datos necesarios estén presentes
				if (!item.id) {
					console.error('❌ ERROR: Dashboard ID es requerido para actualización');
					return Promise.reject(new Error('Dashboard ID es requerido'));
				}
				
				console.log("✅ Dashboard ID válido:", item.id);
				
				// Validar que dashboard sea un array válido
				if (!Array.isArray(item.dashboard)) {
					console.warn('⚠️ WARNING: Dashboard no es un array, convirtiendo...');
					if (typeof item.dashboard === 'string') {
						try {
							item.dashboard = JSON.parse(item.dashboard);
						} catch (e) {
							item.dashboard = [];
						}
					} else {
						item.dashboard = [];
					}
				}
				
				console.log("✅ Dashboard es array válido");
				
				// Validar que options sea un objeto válido
				if (!item.options || typeof item.options !== 'object') {
					console.warn('⚠️ WARNING: Options no es un objeto válido, usando defaults...');
					item.options = {
						draggable: false,
						resizable: true,
						prevent_collision: false,
						vertical_compact: false,
					};
				}
				
				console.log("✅ Options son válidas");
				
				// El camVisibility ya viene inyectado desde el componente
				
				// Solo convertir a string y enviar
				item.dashboard = Helper.to_string(item.dashboard);
				item.options = Helper.to_string(item.options);
				
				console.log("🚀 Enviando actualización al servicio...");
				
				return Service.updateDashboard(item).then(res=>{
					console.log("✅ Respuesta del servicio:", res);
					if (res && res.data) {
						// Corregido: usar item en lugar de params para mantener la consistencia
						commit("editList", item);
						console.log("✅ Lista actualizada en store");
						return Promise.resolve(res);
					}
					console.warn("⚠️ WARNING: Respuesta del servicio sin data");
					return Promise.resolve(res);
				}).catch(error=>{
					console.error("❌ ERROR en servicio updateDashboard:", error);
					return Promise.reject(error);
				});
			} catch (error) {
				console.error("❌ ERROR GENERAL en updateList:", error);
				return Promise.reject(error);
			}
		},
		deleteList({commit}, params){			
			return Service.deleteDashboard(params).then(res=>{
				if (res && res.data) {
					commit("deleteListDashboard", params);
				}
				return Promise.resolve(res);
			}).catch(error=>{
				console.warn("Erro delete list dashboard ", error)
				return Promise.reject(error)
			})
		},
		loadLocalProfile({commit, state, dispatch}, params) {
			return new Promise(async (resolve, reject) => {
				// Fuerza la recarga de la lista SIEMPRE
				await dispatch('getList');

				// Espera a que la lista esté realmente poblada
				let tries = 0;
				while ((!state.list || state.list.length === 0) && tries < 10) {
					await new Promise(res => setTimeout(res, 100));
					tries++;
				}

				// Ahora sí, busca el dashboard por ID
				const find = state.list.find(x => String(x.id) === String(params.id) || Number(x.id) === Number(params.id));
				if (find) {
					const dashboardObj = JSON.parse(JSON.stringify(find));
					let dashboardData = dashboardObj.dashboard;
					if (typeof dashboardData === "string") {
						try {
							dashboardData = JSON.parse(dashboardData);
						} catch (e) {
							dashboardData = [];
						}
					}
					if (!Array.isArray(dashboardData)) {
						dashboardData = [];
					}
					
					// Extraer camVisibility de los widgets parking
					let camVisibility = {};
					dashboardData.forEach(widget => {
						if ((widget.component === 'parking' || widget.component === 'register_events_parking') && widget.camVisibility) {
							camVisibility = { ...widget.camVisibility };
						}
					});
					
					// Restaura todas las propiedades del dashboard, incluyendo camVisibility
					state.currentProfile = {
						...dashboardObj,
						dashboard: dashboardData,
						camVisibility: camVisibility
					};
					
					resolve(true);
					state.functionCheckData();
				} else {
					resolve(null);
				}
			});
		},
		setCamVisibility({ state, commit }, { deviceId, value }) {
			commit('setCamVisibility', { deviceId, value });
		},
		setCamVisibilityAll({ state, commit }, camVisibilityObj) {
			commit('setCamVisibilityAll', camVisibilityObj);
		},
		// Nueva acción para sincronizar camVisibility de manera más robusta
		syncCamVisibility({ state, commit }, camVisibilityObj) {
			try {
				commit('setCamVisibilityAll', camVisibilityObj);
				
				// También actualizar en los widgets del dashboard actual
				if (state.currentProfile && state.currentProfile.dashboard) {
					const updatedDashboard = state.currentProfile.dashboard.map(widget => {
						if (widget.component === 'parking' || widget.component === 'register_events_parking') {
							return { ...widget, camVisibility: { ...camVisibilityObj } };
						}
						return widget;
					});
					
					commit('setProfile', updatedDashboard);
				}
				
				return Promise.resolve(true);
			} catch (error) {
				console.error('❌ ERROR en syncCamVisibility:', error);
				return Promise.reject(error);
			}
		},
		// Nueva acción para preparar un dashboard para edición
		prepareForEdit({ state, commit }, dashboardId) {
			try {
				// Si el dashboard a editar es el actual, preservar el estado local
				if (state.currentProfile && state.currentProfile.id === dashboardId) {
					console.log('🔧 Preservando estado local para edición del dashboard actual');
					return Promise.resolve(state.currentProfile);
				}
				
				// Si no es el actual, cargar desde la lista
				const dashboardFromList = state.list.find(d => d.id === dashboardId);
				if (dashboardFromList) {
					console.log('🔧 Cargando dashboard del servidor para edición');
					return Promise.resolve(dashboardFromList);
				}
				
				return Promise.reject(new Error('Dashboard no encontrado'));
			} catch (error) {
				console.error('❌ ERROR en prepareForEdit:', error);
				return Promise.reject(error);
			}
		},
	},
	mutations:{
		setList(state, list) {
      		state.list = list;
	    },
	    setCurrentProfile(state, item){
      		state.currentProfile = item;	    	
	    },
	    setProfile(state,item){
	    	state.currentProfile.dashboard = item;
	    },
	    setOptions(state,item){
	    	state.currentProfile.options = item;
	    },
	    
		setSidebarGrid(state, val){
			state.sidebarGrid=val;
		},
		setIsLoaded(state, val){
			state.isLoaded=true;
		},
	    setIsLoadingProfile(state,item){
      		state.isLoadingProfile = item;	    		    	
	    },
	    setPositionX(state,val){
      		state.position_x = val;	    		    	
	    },
		setPositionY(state,val){
      		state.position_y = val;	    		    	
	    },
	    setFunctionCheckData(state,val){
	    	state.functionCheckData=val;
	    },
	    deleteElementCurrentProfile(state, val){
	    	if (val >= 0 ) {
	    		state.currentProfile.dashboard.splice(val,1);		
	    	}  
	    },

	    saveLocalProfile(state, val){	    							
	    	let temp = {...state.currentProfile};
	    	if (temp && temp.id) {
	    		delete temp.id;
	    	}
        	localStorage.setItem('changed_profile_dashboard', JSON.stringify({...temp}));
	    },
	    // saveLocalOptions(state, val){	    							
        // 	localStorage.setItem('options_draggable_dashboards', JSON.stringify([...state.currentProfile.options]));
	    // },

	    addItemToCurrentProfile(state, val){
	    	state.currentProfile.dashboard.push(val);
	    },
	    addList(state, list) {
      		state.list.push(list);
	    },
	    editList(state, list){
	    	console.log("🔄 editList mutation llamada con:", list);
	    	if (list && list.id) {
	    		const idx = state.list.findIndex(x=> x.id == list.id)
	    		console.log("📍 Índice encontrado:", idx, "para dashboard ID:", list.id);
	    		if (idx>=0) {
	    			// Crear una copia profunda para evitar problemas de referencia
	    			const updatedItem = JSON.parse(JSON.stringify(list));
	    			state.list.splice(idx, 1, updatedItem);
	    			console.log("✅ Dashboard actualizado en la lista");
	    			
	    			// Si este es el dashboard actual, también actualizar currentProfile
	    			if (state.currentProfile && state.currentProfile.id === list.id) {
	    				console.log("🔄 Actualizando currentProfile porque es el dashboard activo");
	    				// Mantener el dashboard y options como objetos si vienen como strings
	    				let dashboardData = list.dashboard;
	    				let optionsData = list.options;
	    				
	    				if (typeof dashboardData === "string") {
	    					try {
	    						dashboardData = JSON.parse(dashboardData);
	    					} catch (e) {
	    						dashboardData = [];
	    					}
	    				}
	    				
	    				if (typeof optionsData === "string") {
	    					try {
	    						optionsData = JSON.parse(optionsData);
	    					} catch (e) {
	    						optionsData = {};
	    					}
	    				}
	    				
	    				state.currentProfile = {
	    					...state.currentProfile,
	    					...list,
	    					dashboard: dashboardData,
	    					options: optionsData
	    				};
	    				console.log("✅ currentProfile actualizado");
	    			}
	    		} else {
	    			console.warn("⚠️ WARNING: No se encontró dashboard con ID:", list.id);
	    		}
	    	} else {
	    		console.error("❌ ERROR: editList llamado sin list o sin ID");
	    	}
	    },
	    deleteListDashboard(state, list){
	    	if (list && list.id) {
	    		const idx = state.list.findIndex(x=> x.id == list.id)
	    		if (idx>=0) {
	    			state.list.splice(idx,1)
	    		}
	    	}
	    },
	    checkPositions(state){
			let X 			= 0,
				Y 			= 0;
			if (state && state.currentProfile && state.currentProfile.dashboard.length > 0) {
				state.currentProfile.dashboard.forEach( (lay, idx_lay) =>{												
					if (lay.x && lay.w) {
						if (X < lay.x + lay.w) {
							X = lay.x + lay.w; 
						}
						// check its limit
						if (X > 110) {
							X = 0
						}
					}
					if (lay.y && lay.h) {
						if (Y < lay.y) {
							Y = lay.y;
						}
					}
				}); // forEach
				// set positions				
				state.position_x = X;
				state.position_y = Y;
			}
		}, // check positions
		setCamVisibility(state, { deviceId, value }) {
			if (!state.currentProfile.camVisibility) {
				state.currentProfile.camVisibility = {};
			}
			state.currentProfile.camVisibility[deviceId] = value;
		},
		setCamVisibilityAll(state, camVisibilityObj) {
			// Actualizar todo el currentProfile con el nuevo camVisibility
			const updatedProfile = {
				...state.currentProfile,
				camVisibility: { ...camVisibilityObj }
			};
			
			// Usar la mutación existente para actualizar todo el currentProfile
			state.currentProfile = updatedProfile;
		},
	},
}